export default {
  loading: 'Loading authorization request…',
  loadingTitle: 'Preparing a secure connection',
  secureConnection: 'Secure app connection',
  authorizationRequest: 'Authorization request',
  reviewAccess: 'Review access',
  errorTitle: 'Unable to connect Trainn',
  returnToApp: 'Return to requesting app',
  signInTitle: 'Sign in to continue',
  signInDescription: 'Confirm your Trainn identity before choosing what {client} can access.',
  signIn: 'Sign in and continue',
  signInSecurity: 'Your password and Trainn session are never shared with the requesting app.',
  requestsWorkspaceAccess: 'Requests access to a Trainn workspace',
  verifiedClient: 'Verified client',
  unverifiedClient: 'Unverified client name',
  whySignInTitle: 'Why do I need to sign in?',
  whySignInDescription:
    'Signing in lets Trainn verify your identity, workspace membership, and current role before showing any permissions.',
  connectTitle: '{client} wants to connect with Trainn',
  connectDescription:
    'Choose one workspace and review every permission before allowing this connection.',
  workspaceTitle: 'Choose a workspace',
  workspaceDescription: 'The connection is limited to one workspace.',
  chooseWorkspace: 'Select a workspace',
  connectedAs: 'Your role: {role}',
  noWorkspacesTitle: 'No eligible workspaces',
  noWorkspacesDescription:
    'You need an active Trainn workspace membership before you can approve this connection.',
  permissionsTitle: 'Review permissions',
  permissionsDescription: '{client} is requesting the following access.',
  required: 'Required',
  noPermissionsTitle: 'No permissions available',
  noPermissionsDescription:
    'This workspace policy does not allow any of the permissions requested by this app.',
  selectWorkspaceFirst: 'Choose a workspace to continue',
  selectWorkspaceDescription:
    'Available permissions depend on your workspace policy and Trainn role.',
  protectedAccess: 'Your access stays protected',
  securityNotice:
    'This app can access only the selected workspace. Your current Trainn role and workspace policy continue to apply to every action.',
  consentAgreement:
    'By allowing access, you authorize {client} to use only the selected permissions. You can revoke this connection later.',
  oauthProtected: 'Protected by OAuth 2.1 and PKCE',
  unknownClient: 'This application',
  allow: 'Allow access',
  missingRequest: 'The authorization request is missing or invalid.',
  expiredRequest: 'This authorization request has expired or is no longer available. Start the connection again from your MCP app.',
  consentFailed: 'We could not grant access. Review the workspace and permissions, then try again.',
  cancelFailed: 'We could not return to the requesting app. You can safely close this page.',
  scopeGroups: {
    academy: {
      title: 'Academy',
      description: 'Create and manage course drafts and learning content.'
    }
  },
  scopes: {
    trainn: {
      content: {
        read: {
          title: 'Read Trainn content',
          description: 'Search and read content visible to you in this workspace.'
        }
      },
      course: {
        read: {
          title: 'Read courses',
          description: 'View course structure and draft information visible to you.'
        },
        draft: {
          title: 'Create and update course drafts',
          description: 'Create draft courses and edit their structure. Publishing is not included.'
        }
      }
    }
  }
};
